<div
  [ngClass]="
    selectedTopicId === topic?.id
      ? 'topic-card flex-col align-center justify-center active'
      : 'topic-card flex-col align-center justify-center'
  "
>
  <picture class="flex justify-center">
    <img [src]="topic?.img" [alt]="topic?.name" class="topic_image" />
  </picture>
  <h4>{{ topic?.name }}</h4>
  <app-action-menu
    [isOpen]="menuOpen"
    (delete)="handleDelete()"
    (edit)="handleEditTopic()"
    (outsideClick)="closeAllMenu()"
    (open)="openMenu()"
  ></app-action-menu>
</div>
